import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';
import { Subscription, SubscriptionV2 } from '../types/firm';
import { useFirmContext } from '../providers/FirmProvider';

type GetFirmSubscriptionResponse = {
    subscription: Subscription;
};
async function getFirmSubscription(id: string): Promise<GetFirmSubscriptionResponse> {
    const { data } = await api.get(`/firms/${id}/subscription`);
    return data;
}

export function useFirmSubscription(id: string): UseQueryResult<GetFirmSubscriptionResponse, unknown> {
    return useQuery(['firm', id, 'subscription'], () => getFirmSubscription(id), {
        keepPreviousData: false,
    });
}

type GetFirmSubscriptionResponseV2 = {
    subscription: SubscriptionV2;
};
async function getFirmSubscriptionV2(id: string): Promise<GetFirmSubscriptionResponseV2> {
    const { data } = await api.get(`/firms/${id}/subscription/v2`);
    return data;
}

export function useSubscriptionV2(): UseQueryResult<GetFirmSubscriptionResponseV2, unknown> {
    const { id } = useFirmContext();
    return useQuery(['firm', id, 'subscription'], () => getFirmSubscriptionV2(id), {
        keepPreviousData: false,
    });
}
